import format from "date-fns/format"
import parseISO from "date-fns/parseISO"
import isSameDay from "date-fns/isSameDay"
import formatDistanceToNow from "date-fns/formatDistanceToNow"

// date-fns throws RangeError("Invalid time value") when it's handed a
// missing or malformed date — one bad record would take down a whole
// feed render. These wrappers degrade to a placeholder instead.

export const formatPostDate = created => {
  try {
    const date = parseISO(created)
    if (isSameDay(new Date(), date)) {
      return "Today"
    }
    return format(date, "do MMM")
  } catch (e) {
    return "unknown date"
  }
}

export const formatAgo = created => {
  try {
    return formatDistanceToNow(parseISO(created), { addSuffix: true })
  } catch (e) {
    return "unknown date"
  }
}

// Compact uppercase form for tight mobile meta ("2D AGO", "3H AGO").
export const formatAgoCompact = created => {
  try {
    const timestamp = parseISO(created).getTime()
    if (!Number.isFinite(timestamp)) return "UNKNOWN"
    const seconds = Math.max(0, (Date.now() - timestamp) / 1000)
    if (seconds < 60) return "NOW"
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return `${minutes}M AGO`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours}H AGO`
    const days = Math.floor(hours / 24)
    if (days < 30) return `${days}D AGO`
    const months = Math.floor(days / 30)
    if (months < 12) return `${months}MO AGO`
    return `${Math.floor(months / 12)}Y AGO`
  } catch (e) {
    return "UNKNOWN"
  }
}
